<div class="subscription-plan-wrapper">
  <div class="subscription-plan-name-container">
    {{ planName | titlecase }}
  </div>
  <div class="subscription-plan-description-container">
    <app-flex
      direction="column"
      gap="0"
    >
      <div class="subscription-plan-price-container">
        @if (price === 0) {
          <span class="subscription-plan-amount">Free</span>
        }
        @if (price > 0) {
          <span class="subscription-plan-amount">
            {{ price * (isAnnualSubscription ? 0.8 * 12 : 1) | currency: 'USD' : 'symbol' : '1.0-0' }}
          </span>
        }
        <span class="subscription-plan-time-interval">/{{ isAnnualSubscription ? 'year' : 'month' }}</span>
      </div>
      <div class="subscription-plan-description">
        Upfront fee of {{ upfrontFee }}% advanced amount; then {{ fee }}%/week | Ideal for funding needs up to ${{
          eppIdealAmount
        }}/month
        <br />
      </div>
    </app-flex>
    <div>
      @if (selectedPlan !== planName) {
        <button
          mat-flat-button
          class="switch-plan-button"
          color="primary"
          (click)="onSelectSubscriptionPlan(planName)"
        >
          Select
        </button>
      }
      @if (selectedPlan === planName && arePlansExpanded) {
        <button
          mat-stroked-button
          class="switch-plan-button"
          color="primary"
          (click)="onTogglePlansExpanding(false)"
        >
          View less
          <mat-icon
            iconPositionEnd
            class="early-pay-calculator-page-header-back-link-icon"
          >
            arrow_drop_up
          </mat-icon>
        </button>
      }
      @if (selectedPlan === planName && !arePlansExpanded) {
        <button
          mat-stroked-button
          class="switch-plan-button"
          color="primary"
          (click)="onTogglePlansExpanding(true)"
        >
          View more
          <mat-icon
            iconPositionEnd
            class="early-pay-calculator-page-header-back-link-icon"
          >
            arrow_drop_down
          </mat-icon>
        </button>
      }
    </div>
  </div>
</div>
